import styled from 'styled-components';
import PlayerMatchup from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup';
import { cardTypes } from 'bdata-sns-shared/utils/productButtonConfigs';

import {
    PlayerInfoWrapper,
    PlayerNameWrapper,
    PlayerPregameWrapper,
    PlayerDataWrapper,
    PlayerStatsWrapper
} from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';

export const PlayerMatchupScoresOverride = styled(PlayerMatchup)`
    &&& {

        ${PlayerNameWrapper} {
            padding-right: 5px;
            white-space: nowrap;
            ${({ mode }) => (mode === cardTypes.SCOREBOARD)
                ? `
                    overflow: hidden;
                    text-overflow: ellipsis;
                `
                : ''
            }

            ${({ mode }) => (mode === cardTypes.MINI_SB)
                ? `
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-right: 0;
                `
                : ''
            }
        }

        ${PlayerPregameWrapper} {
            font-weight: bold;
            font-size: 11px;
            margin-top: 2px;
            display: inline-block;

            ${({ mode }) => (mode === cardTypes.MINI_SB)
                ? `
                    margin-left: .25em;
                    margin-top: 0;
                `
                : ''
            }
        }

        ${PlayerInfoWrapper} {
            display: flex;
            margin-right: 5px;
        }

        ${PlayerDataWrapper} {
            margin-left: ${({ mode }) => (mode === cardTypes.MINI_SB) ? '0' : '0.5em'};
            flex-wrap: wrap;
            max-width: 100%;

            ${({ mode }) => (mode === cardTypes.SCOREBOARD)
                ? `
                    overflow: hidden;
                `
                : ''
            }

            ${({ mode }) =>
                (mode === cardTypes.MINI_SB)
                    ? ` 
                    
                        > div {
                            > span {
                                height: 15px;
                            }     
                            &:last-child {
                                padding-right: 3px;
                            }
                        }
                    `
                    : ''
            }
        }

        ${PlayerStatsWrapper} {
            ${({ mode }) =>
                (mode === cardTypes.MINI_SB)
                    ? `
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    `
                    : ''
            }
        }
    }

`;
